import { useEffect } from 'react';

const DEFAULT_TITLE = 'Trademark Vector - Professional Trademark & IP Services';
const DEFAULT_DESCRIPTION =
  'Trademark Vector - Professional Trademark and Intellectual Property Services';

const PageMeta = ({ title, description }) => {
  useEffect(() => {
    document.title = title || DEFAULT_TITLE;

    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.setAttribute('name', 'description');
      document.head.appendChild(meta);
    }
    meta.setAttribute('content', description || DEFAULT_DESCRIPTION);

    return () => {
      document.title = DEFAULT_TITLE;
      meta.setAttribute('content', DEFAULT_DESCRIPTION);
    };
  }, [title, description]);

  return null;
};

export default PageMeta;
